import { isLocalDevelop } from "ts-constants";
import { getRuntime } from "utils/runtime";

export function onChangeHeaderLang(lan: string) {
    console.log("切换语言", lan)
	let routerHref: string = location.href.slice(0);
	const originHref = routerHref;
	if (routerHref.match(/com(?!\/active)/gi)) {
		routerHref = routerHref.replace(/\/\w+\/active/, `/${lan}/active`);
	}

	if (isLocalDevelop(getRuntime()?.hostname)) {
		routerHref = routerHref.replace(/\/\w+\/active/g, `/${lan}/active`);
	}
	if (originHref === routerHref) {
		location.reload();
	} else {
		location.replace(routerHref);
	}
}